<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
      <app-main-heading [heading]="'Stock Summary'" class="m-0"></app-main-heading>
      <div class="d-flex justify-content-end align-items-center flex-wrap gap-2 ms-auto">
        <button class="btn fw-bold filter-toggle m-1" (click)="openFilterPanel()">
          <fa-icon class="me-1 text-dark" [icon]="faSliders" size="sm"></fa-icon>
          <span class="text-dark fw-bold small">Filters</span>
          <fa-icon class="ms-1" [icon]="showFilterPanel ? faAngleDown : faAngleUp" size="sm"></fa-icon>
        </button>
        <button class="btn app-btn-primary text-end m-1" [routerLink]="'view-import-stock-list'" routerLinkActive="active"
          [disabled]="isStockListButtonDisabled">
          <fa-icon [icon]="faEye"></fa-icon> Stock Summary</button>
        <button class="btn app-btn-primary text-end m-1" (click)="exportStockData()" [disabled]="isButtonDisabled">
          <fa-icon [icon]="isButtonDisabled ? faLoader : faDownload"
            [animation]="isButtonDisabled ? 'spin' : undefined">
          </fa-icon>
          <span class="button-text">
            {{ isButtonDisabled ? 'Download' : 'Download' }}
          </span>
        </button>
      </div>
    </div>

    @if (showFilterPanel) {
    <div class="card filter-card p-3 p-md-4 rounded-4 shadow-sm mb-3">
      <div class="row g-2 justify-content-start align-items-end">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="tyreSizeInput" class="filter-label">Tyre Size</label>
          <input id="tyreSizeInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Size"
            [(ngModel)]="filtersForm.tyreSize" (ngModelChange)="inputChangeFilter()" />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="brandInput" class="filter-label">Brand</label>
          <input id="brandInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Brand"
            [(ngModel)]="filtersForm.tyreMake" (ngModelChange)="inputChangeFilter()" />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="patternInput" class="filter-label">Pattern</label>
          <input id="patternInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Model"
            [(ngModel)]="filtersForm.tyreModel" (ngModelChange)="inputChangeFilter()" />
        </div>
        @if(isBranchVisible){
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="branchSelect" class="filter-label">Branch</label>
          <ng-select labelForId="branchSelect" [items]="companyData" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [searchable]="true" placeholder="Select Branch..." [trackByFn]="trackById"
            (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.branch" class="ng-select-bootstrap"
            appendTo="body">
          </ng-select>
        </div>
        }
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="agingPeriodSelect" class="filter-label">Aging Period</label>
          <ng-select labelForId="agingPeriodSelect" [items]="dateRange" [(ngModel)]="filtersForm.lastSale" bindLabel="label" bindValue="value"
            [clearable]="true" placeholder="Select Aging Period..." class="ng-select-bootstrap" (change)="onChangeApplyFilter()"
            [searchable]="false" appendTo="body">
          </ng-select>
        </div>
      </div>
    </div>
    }

    <div class="row">
      <div class="col-12">
        <div class="card app-table-thick-border shadow-none mb-2">
          <div class="table-responsive app-scrollbar">
            <table class="table app-table-rounded align-middle m-0 w-100">
              <thead>
                <tr class="app-table-header text-nowrap">
                  @for (header of headers; track header; let i = $index) {
                  <th (click)="sortData(header, i)">
                    {{header.value.toUpperCase()}}
                    @if (i !== 2) {
                      @if (header.sortDir === 1) {
                      <fa-icon [icon]="faArrowUp"></fa-icon>
                      }
                      @if (header.sortDir === -1) {
                      <fa-icon [icon]="faArrowDown"></fa-icon>
                      }
                      @if (!header.sortDir) {
                      <fa-icon [icon]="faSort"></fa-icon>
                      }
                      }
                  </th>
                  }
                </tr>
              </thead>
              <tbody class="app-td-text">
                @for (row of data; track row; let i = $index) {
                <tr class="home-table-row"
                    [class.group-last-row]="i === data.length - 1 || data[i + 1]?.[0]?.brandIndex !== row[0]?.brandIndex">
                  @for (cell of row; track cell; let cellIndex = $index) {
                  <td [ngClass]="(i === 0 || data[i - 1]?.[0]?.brandIndex !== row[0]?.brandIndex) ? 'td-text-three' : 'td-text-two text-muted'">
                    <ng-container>
                      {{ cell.value }}
                    </ng-container>
                  </td>
                  }
                </tr>
                }

                @if (loader) {
                  <tr>
                    <td [attr.colspan]="headers.length">
                      <div class="d-flex justify-content-center py-5">
                        <app-loader [loadingIcon]="loader"></app-loader>
                      </div>
                    </td>
                  </tr>
                }

                @if (!loader && data.length === 0) {
                  <tr>
                    <td [attr.colspan]="headers.length">
                      <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                        No data Found!
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

@if (isToster) {
<app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}